// mock t function for i18next scanner to pick up
const t = (x: string) => x

export enum IxAuftragStatusFilter {
    eAlle = 0,
    eOffen = 1,
    eNeu = 2,
    eInBearbeitung = 3,
    eErledigt = 4,
    eStorniert = 5,
}

export const IxAuftragStatusFilterLabels: {[k: string]: string} = {
    [IxAuftragStatusFilter.eAlle]: t('auftrag:enum.IxAuftragStatusFilter.eAlle'),
    [IxAuftragStatusFilter.eOffen]: t('auftrag:enum.IxAuftragStatusFilter.eOffen'),
    [IxAuftragStatusFilter.eNeu]: t('auftrag:enum.IxAuftragStatusFilter.eNeu'),
    [IxAuftragStatusFilter.eInBearbeitung]: t('auftrag:enum.IxAuftragStatusFilter.eInBearbeitung'),
    [IxAuftragStatusFilter.eErledigt]: t('auftrag:enum.IxAuftragStatusFilter.eErledigt'),
    [IxAuftragStatusFilter.eStorniert]: t('auftrag:enum.IxAuftragStatusFilter.eStorniert'),
}

export const ixAuftragStatusFilterToOpts = (t: Function, settings: any) => {
    const opts = []

    for(let x in IxAuftragStatusFilter) {
        if (!isNaN(Number(x))) { continue }


        opts.push({
            name: t(IxAuftragStatusFilterLabels[IxAuftragStatusFilter[x as keyof typeof IxAuftragStatusFilter]]),
            value: IxAuftragStatusFilter[x as keyof typeof IxAuftragStatusFilter],
        })
    }

    return opts
}
